/* eslint-disable no-dupe-keys */
export default {
  idle_fee_bill_settlement: {
    name: '占位费账单结算',
    // 属性（一般与对象内容匹配）
    prop: {
      trade_number: '单号',
      ev_charging_station: '电站',
      idle_fee_bill: '占位费账单',
      station_settlement: '站结算记录',
      sharing_amount: '分成金额',
      idle_fee_amount: '占位费金额',
      idle_fee_begin_at: '占位开始时间',
      idle_fee_finished_at: '占位结束时间',
      amount: '实付金额',
      tax_amount: '占位费税费',
      net_income_amount: '运营商净收入',
      transaction_fee_amount: '占位费交易手续费',
      user: '用户',
      settled_at: '结算执行时间',
      created_at: '创建时间',
      updated_at: '更新时间',
      ev_charging_station: '充电站',
      service_provider: '运营商',
      paid_at: '账单支付时间'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标题
    titles: {
      idle_fee_bill_info: '占位费信息'
    },
    labels: {
      idle_fee_amount: '占位费金额',
      idle_fee_bills_amount: '占位费结算总额',
      discount_amount: '优惠金额',
      transaction_fee_amount: '占位费交易手续费',
      tax_amount: '占位费税费'
    },
    columns: {
      net_income_amount: '净收入',
      tax_amount: '占位费税费'
    }
  }
}
